export class ErrorStorage {
  static key = 'consentError';

  static setError = () => {
    window.sessionStorage.setItem(ErrorStorage.key, 'true');
  };

  static clearError = () => {
    window.sessionStorage.removeItem(ErrorStorage.key);
  };

  static hasError = () => {
    const value = window.sessionStorage.getItem(ErrorStorage.key);
    return value === 'true';
  };
}
